//styling
import '../tailwind.css';
import '../hjemmet.scss';

//javascript
import '../../shared/global/scripts/_main-navigation.js';
import '../../shared/global/scripts/_nav-item.js';

import initFeedBlock from '../../shared/global/scripts/_feed-block.js';
import initBlockTracking from '../../shared/global/scripts/_block-tracking.js';
import initDropdownBlock from '../../shared/global/scripts/_dropdown-block.js';
import initLoadingScreen from '../../shared/global/scripts/_loading-screen.js';
import initCountdownBlock from '../../shared/global/scripts/_countdown-block.js';
import initFormBlock from '../../shared/global/scripts/_form-block.js';
import initGridBlockFilter from '../../shared/global/scripts/_grid-block-filter.js';
import initGridMasonry from '../../shared/global/scripts/_grid-masonry.js';
import initInfiniteSlider from '../../shared/global/scripts/_infinite-slider-block.js';

// Clicks in blocks an editor marked "Track Clicks" → GTM dataLayer
initBlockTracking();

// Initialize all feed blocks on the page
document.addEventListener("DOMContentLoaded", () => {
    const loadingScreen = document.querySelector(".loading-screen");
    if (loadingScreen) initLoadingScreen(loadingScreen);

    const feedBlocks = document.querySelectorAll(".feed-block");
    feedBlocks.forEach(block => initFeedBlock(block));

    const dropdownBlocks = document.querySelectorAll(".dropdown-block");
    dropdownBlocks.forEach(block => initDropdownBlock(block));

    const countdownBlocks = document.querySelectorAll(".countdown-block");
    countdownBlocks.forEach(block => initCountdownBlock(block));

    const formBlocks = document.querySelectorAll("[data-form-block]");
    formBlocks.forEach(block => initFormBlock(block));

    const gridBlocks = document.querySelectorAll(".grid-block");
    gridBlocks.forEach(block => initGridBlockFilter(block));
    gridBlocks.forEach(block => initGridMasonry(block));

    const infiniteSliders = document.querySelectorAll(".infinite-slider");
    infiniteSliders.forEach(slider => initInfiniteSlider(slider));
});
